(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventahoyrealtime', {
            parent: 'entity',
            url: '/ventahoyrealtime',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventahoyrealtime.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtimes.html',
                    controller: 'VentahoyrealtimeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventahoyrealtime');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventahoyrealtime-detail', {
            parent: 'ventahoyrealtime',
            url: '/ventahoyrealtime/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventahoyrealtime.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-detail.html',
                    controller: 'VentahoyrealtimeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventahoyrealtime');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventahoyrealtime', function($stateParams, Ventahoyrealtime) {
                    return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventahoyrealtime',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventahoyrealtime-detail.edit', {
            parent: 'ventahoyrealtime-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventahoyrealtime.new', {
            parent: 'ventahoyrealtime',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fechaproceso: null,
                                cantpv: null,
                                totalmonto: null,
                                totaltickets: null,
                                totalitems: null,
                                hora: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('ventahoyrealtime');
                });
            }]
        })
        .state('ventahoyrealtime.edit', {
            parent: 'ventahoyrealtime',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-dialog.html',
                    controller: 'VentahoyrealtimeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventahoyrealtime.delete', {
            parent: 'ventahoyrealtime',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventahoyrealtime/ventahoyrealtime-delete-dialog.html',
                    controller: 'VentahoyrealtimeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventahoyrealtime', function(Ventahoyrealtime) {
                            return Ventahoyrealtime.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventahoyrealtime', null, { reload: 'ventahoyrealtime' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
